<template>

	<div>
		<FileBrowser :axiosConfig="axiosConfig"></FileBrowser>
	</div>

</template>

<script>

import FileBrowser from '@/components/file-browser/FileBrowser';
import { parseCookies } from '@/utils/cookie';

export default {
	components: {
		FileBrowser
	},
	data () {
		const portletId = parseCookies('portletId', true);
		this.$store.commit('setCurrentDocsPortlet', portletId);
		if (process.env.NODE_ENV === 'development' &&
			process.env.VUE_APP_DATA_SOURCE === 'live') {
			return {
				axiosConfig: {
					baseURL: window.location.origin
				}
			};
		} else {
			return {
				axiosConfig: {
					baseURL: ''
				}
			};
		}
	}

};
</script>
